import { render, staticRenderFns } from "./BankAccountInfo.vue?vue&type=template&id=0af2799c&scoped=true"
import script from "./BankAccountInfo.vue?vue&type=script&lang=js"
export * from "./BankAccountInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2799c",
  null
  
)

export default component.exports